module.exports = __webpack_public_path__ + "img/about2.a245c7ba.jpg";